import { type FC, memo } from "react";
import Image from "components/Image";
import style from "./style.module.scss";
import clsx from "clsx";
import Link from "next/link";

interface IProps {
  image: string;
  alt: string;
  title: string;
  moreInfo: string[];
  link: string;
}

const PersonCard: FC<IProps> = ({ image, alt, title, link, moreInfo }) => {
  return (
    <Link href={link}>
      <a
        className={clsx(
          "md:tw-flex tw-w-full tw-rounded-xl tw-border tw-border-solid tw-border-[#E5E9F4] tw-bg-white",
          style.card
        )}
      >
        <div className="tw-p-2.5 tw-w-full md:tw-w-[170px]">
          <div className="tw-overflow-hidden tw-rounded-md tw-aspect-square">
            <Image
              src={image}
              width={150}
              height={150}
              className="tw-rounded-md tw-w-full tw-h-full"
              alt={alt}
              loading="eager"
            />
          </div>
        </div>
        <div className="tw-p-4 tw-w-full md:tw-w-[calc(100%-170px)]">
          <h6 className="tw-mb-[15px] tw-text-sm xxxl:tw-text-base tw-font-medium tw-text-[#344456]">
            {title}
          </h6>
          {moreInfo.slice(0, 2).map((item, i) => (
            <p
              key={i}
              className="tw-mb-[15px] tw-text-xs xxxl:tw-text-sm tw-font-medium tw-text-[#344456]"
            >
              <span>{item}</span>
            </p>
          ))}
        </div>
      </a>
    </Link>
  );
};

export default memo(PersonCard);
